import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import HeaderBox from "../reuseableComponents/headerBox";
import { GET_APP_MENU } from "../../queries/menuQrys/baseWLMenuQrys";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import MenuCard from "../reuseableComponents/MenuCard";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import ErrorHandler from "../reuseableComponents/ErrorHandler";

const menuIcons = {
  FILE_UPLOAD: faCloudUploadAlt
};

const PortalIndex = () => {
  const { loading, error, data } = useQuery(GET_APP_MENU, { variables: { menu: "PORTAL" } });
  if (loading || error)
    return (
      <div className='page-container portal-index-container'>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='portalIndexPage'>
              <h1 className="main-section-title">Portal</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            {loading ? <SkeletonLoader width='100%' /> : ""}
            {error ? <ErrorHandler error={error} /> : ""}
          </Col>
        </Row>
      </div>
    );

  return (
    <div className='page-container portal-index-container'>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='portalIndexPage'>
            <h1 className="main-section-title">Portal</h1>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        {data.getAppMenu.map((module) => (
          <Col md={4} key={module.value}>
            <MenuCard icon={menuIcons[module.value]} module={module.value} route={module.route} name={module.label} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PortalIndex;
